import { useEffect, useState } from "react";
import { PAGES } from "../../../routeConfig";
import { Link } from "react-router-dom";
import { useNoteAlert } from "../../../Context/pleaseNote";

export const AddressCard = ({ data, handleDelete }) => {
  const [address, setAddress] = useState(null);
  const { showDialogAlert, showFlashScreen, hideNoteAlert } = useNoteAlert();
  useEffect(() => {
    setAddress(data);
  }, [data]);

  const handleDeleteClick = (e) => {
    e.preventDefault();
    showDialogAlert({
      content: "Do you want to delete this address permanently?",
      title: "Delete Confirmation",
      primaryBtn: {
        caption: "Yes, Remove",
        onClick: () => {
          handleDelete(data.id);
          hideNoteAlert();
        },
      },
      scondaryBtn: { caption: "Cancel", onClick: hideNoteAlert },
    });
  };

  return (
    <div className="col-sm-6 col-lg-4 mt-4" key={data.id}>
      <div className="create-favListAdd hover-left ">
        <div className="favListing">
          <div className="addressDetails">
            <address className="text-dark">
              <b>{data.shipTo}</b>
              <br />
              {data.attentionTo},
              <br />
              {data.address1},
              <br />
              {data.address2 && (
                <>
                  {data.address2},<br />
                </>
              )}
              {data.suburb},
              <br />
              {data.state}-{data.postCode} , {data.country}
            </address>
            <div className="addressDetails-contact mt-3">
              <p>
                <b>Phone Number:</b> {data.phone}
              </p>
            </div>
          </div>
        </div>
        <div className="favListing-links">
          <Link
            to={`${PAGES.MYADDRESSBOOK}/edit/${data.id}`}
            className="favListing-links-edit"
          >
            Edit
          </Link>
          <a className="favListing-links-delete" onClick={handleDeleteClick}>
            Delete
          </a>
        </div>
      </div>
    </div>
  );
};
